import { render, staticRenderFns } from "./NeiBuFile2.vue?vue&type=template&id=989e3c64&scoped=true&"
import script from "./NeiBuFile2.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile2.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile2.vue?vue&type=style&index=0&id=989e3c64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989e3c64",
  null
  
)

export default component.exports